export const MAP_GEOFENCES_ASSIGN_OPEN_CLOSE_MODAL = "MAP_GEOFENCES_ASSIGN_OPEN_CLOSE_MODAL";

export const MAP_GEOFENCES_ASSIGN_GET_UNIT_GEOFENCE = "MAP_GEOFENCES_ASSIGN_GET_UNIT_GEOFENCE";
export const MAP_GEOFENCES_ASSIGN_GET_UNIT_GEOFENCE_RESPONSE = "MAP_GEOFENCES_ASSIGN_GET_UNIT_GEOFENCE_RESPONSE"

export const MAP_GEOFENCES_ASSIGN_SAVE = "MAP_GEOFENCES_ASSIGN_SAVE";
export const MAP_GEOFENCES_ASSIGN_SAVE_RESPONSE = "MAP_GEOFENCES_ASSIGN_SAVE_RESPONSE";